module.exports = __webpack_public_path__ + "static/img/wxqr.ad955b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/wxqr.jpg
// module id = wLmN
// module chunks = 1